import Api from "..";

const getDashboardData = async (filtros = {}) => {
    try {
        const params = new URLSearchParams(filtros).toString();
        const response = await Api.get(`/relatorios/dashboard?${params}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar dados do dashboard: ${error.message}`);
    }
};

const buscarStatusUsuario = async (termo = '', page = 1, limit = 10, perfil = '', statusSenha = '', dataInicio = '', dataFim = '') => {
    try {
        const response = await Api.get(`/relatorios/status-usuario`, {
            params: { q: termo, page, limit, perfil, statusSenha, dataInicio, dataFim }
        });
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar status do usuário: ${error.message}`);
    }
};

const getUsuariosAtivosAgora = async (filtros = {}) => {
    try {
        const params = new URLSearchParams(filtros).toString();
        const response = await Api.get(`/relatorios/ativos-agora?${params}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar usuários ativos agora: ${error.message}`);
    }
};

const getRankingCongregacoes = async (filtros = {}, tipo = 'cadastrados') => {
    try {
        const params = new URLSearchParams({ ...filtros, tipo }).toString();
        const response = await Api.get(`/relatorios/ranking-congregacoes?${params}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar ranking: ${error.message}`);
    }
};

const RelatoriosService = {
    getDashboardData,
    buscarStatusUsuario,
    getUsuariosAtivosAgora,
    getRankingCongregacoes
};

export default RelatoriosService;
